import { useCallback, useEffect, useState } from 'react';
import ProtocolService from '../../../../service';

export const useCustomFieldsValues = (
  protocolId,
  prevRecordTypeId,
  selectedRecordType
) => {
  const [customFieldsValues, setCustomFieldsValues] = useState([]);
  const [prevCustomFieldsValues, setPrevCustomFieldsValues] = useState([]);

  const fetchCustomFieldsValues = useCallback(async () => {
    if (!protocolId || !selectedRecordType) return;
    try {
      const response = await ProtocolService.getCustomFieldsValues(
        protocolId,
        selectedRecordType
      );
      setCustomFieldsValues(response?.data || []);
    } catch (error) {
      console.error('Erro ao buscar valores dos campos customizados:', error);
      setCustomFieldsValues([]);
    }
  }, [protocolId, selectedRecordType]);

  useEffect(() => {
    if (protocolId && prevRecordTypeId)
      ProtocolService.getCustomFieldsValues(protocolId, prevRecordTypeId)
        .then((response) => {
          setPrevCustomFieldsValues(response?.data || []);
        })
        .catch((error) => {
          console.error(
            'Erro ao buscar valores dos campos customizados anteriores:',
            error
          );
          setPrevCustomFieldsValues([]);
        });
  }, [protocolId, prevRecordTypeId]);

  return {
    customFieldsValues,
    setCustomFieldsValues,
    prevCustomFieldsValues,
    setPrevCustomFieldsValues,
    fetchCustomFieldsValues
  };
};
